import { nanoid } from '@reduxjs/toolkit'

import zapier from './brand/zapier.svg?url'
import calendly from './brand/calendly.png'
import happyfox from './brand/happyfox.svg?url'
import restAPI from './brand/rest-api.svg?url'
import googleAnalytics from './brand/google-analytics.svg?url'

const appsList = [
  {
    app_type: 'happyfox_helpdesk',
    name: 'Happyfox Helpdesk',
    description: 'Create tickets on HappyFox Helpdesk for every bot conversation',
    brandImage: happyfox,
    supportArticleLink: '',
    public: true
  },
  {
    app_type: 'happyfox_workflows',
    name: 'HappyFox Workflows',
    description: 'Trigger a HappyFox Workflow and display results during a conversation',
    brandImage: happyfox,
    supportArticleLink: '',
    public: true
  },
  {
    app_type: 'happyfox_chat',
    name: 'HappyFox Chat',
    description: 'Transfer bot conversations to live chat agents in real time',
    brandImage: happyfox,
    supportArticleLink: '',
    public: true
  },
  {
    app_type: 'calendly',
    name: 'Calendly',
    description: 'Schedule meetings on Calendly using HappyFox Chatbot',
    brandImage: calendly,
    supportArticleLink: '',
    public: true
  },
  {
    app_type: 'zapier',
    name: 'Zapier',
    description: 'Send events to Zapier and render results of your Zap in chatbot',
    brandImage: zapier,
    supportArticleLink: '',
    public: true
  },
  {
    app_type: 'rest_api',
    name: 'Rest API',
    description: 'HappyFox Chat REST API provides read-only access to your data for use in your application',
    brandImage: restAPI,
    supportArticleLink: '',
    public: true
  },
  {
    app_type: 'google_analytics',
    name: 'Google Analytics',
    description: 'Freemium web analytics service offered by Google that tracks and reports website traffic.',
    brandImage: googleAnalytics,
    supportArticleLink: '',
    public: true
  }
]

const attachViewKey = (apps) => {
  return apps
    .map((app) => {
      return {
        ...app,
        viewKey: nanoid()
      }
    })
    .filter((app) => app.public)
}

export default attachViewKey(appsList)
